import {
  Card,
  Link as ExternalLink,
  Heading,
  Paragraph,
} from "@digdir/designsystemet-react";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { cn } from "@/utils";

export const VeiledningLenke = ({ className }: { className?: string }) => {
  const { t } = useTranslation();

  return (
    <Card className={cn(className, "space-y-5")}>
      <Heading>{t("pages.veiledning.tittel")}</Heading>
      <Paragraph>{t("pages.veiledning.lenke-beskrivelse")}</Paragraph>
      <ExternalLink asChild>
        <Link to={"/veiledning"} className="mt-6">
          <Paragraph> {t("pages.veiledning.lenke-tekst")}</Paragraph>
        </Link>
      </ExternalLink>
    </Card>
  );
};
